<template>
    <div>
        <div class="afu-text-xs afu-text-gray-600 afu-pl-4 afu-pt-4 afu-pb-3">
            Select from the list below or add more using the search box above
        </div>

        <div
            v-for="category in jobCategories"
            :key="category.id"
            class="afu-py-1"
        >
            <div
                class="afu-flex afu-items-center afu-justify-between afu-px-4 afu-text-sm afu-text-black afu-mb-1 afu-cursor-pointer"
                @click="toggleCategory(category)"
            >
                {{ category.name }}

                <FontAwesomeIcon
                    :icon="category.is_open ? ['far', 'chevron-up'] : ['far', 'chevron-down']"
                    fixed-width
                    class="afu-text-gray-600"
                    style="font-size: 10px;"
                />
            </div>

            <ul
                v-show="category.is_open"
                class="afu-border afu-border-solid afu-border-gray-200 afu-bg-gray-100 afu-mx-4 afu-px-0 afu-py-3 afu-list-none afu-rounded-md"
            >
                <li
                    v-for="occupation in category.occupations"
                    :key="occupation.id"
                    tabindex="0"
                    @click="selectOccupation(category, occupation)"
                    class="af-occupation-select-item afu-block afu-px-5 afu-py-2 afu-text-sm afu-leading-5 afu-text-black afu-cursor-pointer"
                    :class="{ 'afu-font-bold': occupation.is_selected }"
                >
                    {{ occupation.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'C1ClsSelectClsList',

        props: {
            jobCategories: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
            };
        },

        methods: {
            toggleCategory(category) {
                category.is_open = !category.is_open;
            },

            selectOccupation(category, occupation) {
                this.$emit('selectOccupation', { category, occupation });
            },
        },
    };
</script>
